import React, {useEffect, useRef, useContext, useState} from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import EncDateRangePicker from '../../../../components/date-range-picker/index';
import { Button } from 'semantic-ui-react';
import NoResultsMessage from '../../../../components/table-select/NoResultsMessage';
import PageableTableSelect from '../../../../components/table-select/pageable/index';
import columnConfig from './account-transactions.column-config';
import { MobXProviderContext } from 'mobx-react';
import { useParams } from 'react-router-dom';

const AccountTransactions = observer(() => {
    const { t } = useTranslation();
    const { accountId } = useParams();
    const { transactionStore, accountTransactionsUIStore, accountStore, headerUIStore } = useContext(MobXProviderContext);
    const tableSelectRef = useRef(null);
    const [tableSelectFilter, setTableSelectFilter] = useState('');

    const setTableSelectRef = (node) => {
        tableSelectRef.current = node;
    };

    useEffect(() => {
        accountStore.retrieveAccount(accountId)
            .then(() => headerUIStore.setTitleKey(accountStore.account.name));

        return () => {
            accountTransactionsUIStore.reset();
        };
    }, [accountId, accountStore, accountTransactionsUIStore, headerUIStore]);

    useEffect(() => {
        if (tableSelectRef && tableSelectRef.current) {
            tableSelectRef.current.refreshTable();
        }
    }, [accountTransactionsUIStore.dateRange]);

    const exportToCSV = () => {
        transactionStore.exportToCsv(
            accountTransactionsUIStore.dateRange,
            tableSelectFilter,
            { accountId: accountId, accountName: accountStore.account.name }
        );
    };

    const handleTextFilterChange = filter => {
        if (tableSelectRef && tableSelectRef.current) {
            setTableSelectFilter(filter);
        }
    };

    const getPageableTransactions = (...params) => {
        transactionStore.getPageableTransactions(accountTransactionsUIStore.dateRange, accountId)(...params);
    };

    const renderAdditionalFilteringComponents = () => (
        <EncDateRangePicker
            startDate={accountTransactionsUIStore.dateRange.startDate}
            endDate={accountTransactionsUIStore.dateRange.endDate}
            handleRange={dateRange => {
                accountTransactionsUIStore.setDateRange(dateRange);
                if (tableSelectRef && tableSelectRef.current) {
                    tableSelectRef.current.refreshTable();
                }
            }}
        />
    );

    const renderNoResultsMessage = () => (
        <NoResultsMessage
            startDate={accountTransactionsUIStore.dateRange.startDate}
            endDate={accountTransactionsUIStore.dateRange.endDate}
        />
    );

    return (
        <div className="content sticky-scroll">
            <div className="section__full--width--padding mt-4">
                <Button className="button__primary" onClick={exportToCSV}>
                    {t('common:common.export.to.csv')}
                </Button>
            </div>

            <div className="sticky-scroll">
                <PageableTableSelect
                    multiSelect={false}
                    columnConfig={columnConfig}
                    fetchPageableData={getPageableTransactions}
                    rowId="id"
                    isSticky={true}
                    stickyTopOffset={55}
                    stickyTopBarOffset={0}
                    dataName={t('account.transactions')}
                    additionalFilteringComponents={renderAdditionalFilteringComponents()}
                    selectable={false}
                    noDataText={renderNoResultsMessage()}
                    defaultColumnSorted="endTransaction"
                    tableSelectRef={setTableSelectRef}
                    handleTextFilterChange={handleTextFilterChange}
                />
            </div>
        </div>
    );
});

export default AccountTransactions;
